import BlessButton from "@/components/layout/button/green-outline-btn";
import BlessModal from "@/components/layout/modal/bless-modal";
import {
  REMOVE_ALL_GRANTED_PERMS_DIALOGUE,
  REMOVE_ALL_RECEIVED_PERMS_DIALOGUE,
} from "@/constants/mod-perms-tool.constants";
import useModularPermissionsManager from "@/features/mod-perms/hooks/useModularPermissions.hook";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import React, { useState } from "react";
import { ImBin } from "react-icons/im";
import styles from "../action-btns.module.scss";
import classNames from "classnames";
import { CgClose } from "react-icons/cg";
import ConfirmWindow from "@/features/mod-perms/components/modal/confirm-window";

type Props = {};

const RemoveAllBtn = (props: Props) => {
  const [open, setOpen] = useState(false);
  const { isDelegateContextGranted, delegatePermissions, receivedPermissions } =
    useModularPermissionsStore();
  const { contractClient } = useModularPermissionsManager();

  const permissions = isDelegateContextGranted()
    ? delegatePermissions
    : receivedPermissions;

  if (permissions.length)
    return (
      <>
        <button
          className={classNames(styles.actionBtn, styles.removeAllBtn)}
          onClick={() => setOpen(true)}
        >
          <ImBin size={15} /> <span>Remove all</span>
        </button>
        <BlessModal
          open={open}
          closeIcon={<CgClose size={18} />}
          onCancel={() => setOpen(false)}
        >
          <ConfirmWindow
            header="Warning!"
            paragraph={
              isDelegateContextGranted()
                ? REMOVE_ALL_GRANTED_PERMS_DIALOGUE
                : REMOVE_ALL_RECEIVED_PERMS_DIALOGUE
            }
            onCancel={() => setOpen(false)}
            onConfirm={() =>
              isDelegateContextGranted()
                ? contractClient.removeAllDelegations(setOpen)
                : contractClient.removeAllReceivedDelegations(setOpen)
            }
          />
        </BlessModal>
      </>
    );
};

export default RemoveAllBtn;
